document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.getElementById('videoTrigger');
    const modal = document.getElementById('videoModal');
    const closeBtn = document.getElementById('closeVideo');
    const videoIframe = document.getElementById('videoIframe');

    trigger.addEventListener('click', function () {
      modal.style.display = 'flex';
      // Optional: Autoplay video when opened
      const src = videoIframe.src;
      videoIframe.src = src + '&autoplay=1';
    });

    closeBtn.addEventListener('click', function () {
      modal.style.display = 'none';
      // Stop video on close
      videoIframe.src = videoIframe.src.replace('&autoplay=1', '');
    });

    // Close modal when clicking outside the video
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeBtn.click();
      }
    });
  });

jQuery(document).ready(function($) {
    $('.testimonial-slide ul').slick({
        dots: true,
	      arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        //autoplay: true,
        autoplaySpeed: 2000,

        responsive: [
            {
            breakpoint: 1081,
            settings: {
            slidesToShow: 2
             }
        },
            {
    
            breakpoint: 681,
    
            settings: {
    
              slidesToShow: 1
    
            }
    
          }
    
        ]
       
  }); 
});


jQuery(document).ready(function($) {
  $('.product-slider ul').slick({
      dots: false,
     arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,

      responsive: [
          {
          breakpoint: 1281,
          settings: {
          slidesToShow: 4
           }
      },
      {
        breakpoint: 981,
        settings: {
        slidesToShow: 3
         }
    },
          
          {
  
            breakpoint: 481,
    
            settings: {
    
              slidesToShow: 2
    
            }
  
        }
  
      ]
     
}); 
});